import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";

import Clear from "@material-ui/icons/Clear";

import withStyles from "@material-ui/core/styles/withStyles";

const styles = theme => ({
  row: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between"
  },
  input: {
    flexGrow: 1,
    backgroundColor: "white",
    color: "black",
    paddingLeft: 5,
    marginTop: 5
  },
  textField: {
    width: "100%",
    margin: "5px 0"
  },
  label: {
    color: "white"
  },
  button: {
    marginBottom: 3
  }
});

const AddZoneForm = props => {
  const { classes, zoneName, changeInputValue, clearAddZoneForm, submitAddZoneForm } = props;
  return (
    <div className={classes.row}>
      <TextField
        className={classes.textField}
        label="Наименование зоны"
        name="zoneName"
        value={zoneName}
        onChange={changeInputValue}
        InputLabelProps={{
          classes: { root: classes.label },
          shrink: true
        }}
        InputProps={{ classes: { input: classes.input } }}
      />
      <IconButton onClick={clearAddZoneForm}>
        <Clear color="error" />
      </IconButton>
      <Button color="primary" onClick={submitAddZoneForm} className={classes.button}>
        ОК
      </Button>
    </div>
  );
};

export default withStyles(styles)(AddZoneForm);

AddZoneForm.propTypes = {
  classes: PropTypes.object,
  zoneName: PropTypes.string,
  changeInputValue: PropTypes.func.isRequired,
  clearAddZoneForm: PropTypes.func.isRequired,
  submitAddZoneForm: PropTypes.func.isRequired
};
